import Vue from 'vue'
import Branches from './branches.vue'

const ROLE_VALUE_OF_DEFAULT = "default"

document.addEventListener('DOMContentLoaded', () => {
  const makeMailForm = document.getElementById('make-mail-form')
  if(makeMailForm) {
    const topics = JSON.parse(makeMailForm.dataset.topics)
    const group = ['central', 'locally', 'cooperative_social']
    const independents = topics.filter(t => !group.includes(t))
    const adminOnly = ['emergency', 'central', 'cooperative_social']

    const props = JSON.parse(makeMailForm.dataset.props)
    Vue.component('branches', Branches)

    new Vue({
      el: makeMailForm,
      data: {
        ...props,
        selections: {
          branchIds: {},
          groupIds: {}
        }
      },
      watch: {
        emergency: function(val) {
          if (val) {
            this.obituary = false
            this.central = false
            this.locally = false
            this.cooperative_social = false
            this.updateSelectedBranches()
          }
        },
        obituary: function(val) {
          if (val) {
            this.emergency = false
            this.central = false
            this.locally = false
            this.cooperative_social = false
            this.updateSelectedBranches()
          }
        },
        central: function(val) {
          if (val){
            this.emergency = false
            this.obituary = false
            this.updateSelectedBranches()
          }
        },
        locally: function(val) {
          if (val){
            this.emergency = false
            this.obituary = false
          }
          this.updateSelectedBranches()
        },
        cooperative_social: function(val) {
          if (val){
            this.emergency = false
            this.obituary = false
          }
        }
      },
      computed: {
        computedBrachIds: function() {
          if (this.emergency || this.obituary || this.central) {
            return this.branches.map(b => b.id)
          } else if (this.locally) {
            return this.targetBranchIds
          } else {
            return []
          }
        },
        otherBranchIds: function() {
          const ids = this.computedBrachIds
          return this.branches.map(b => b.id).filter(id => !ids.includes(id))
        }
      },
      methods: {
        updateSelectedBranches() {
          if (this.emergency || this.obituary || this.central || this.locally) {
            this.selectBranches(this.computedBrachIds, true)
            this.selectGroups(this.getGroupIds(this.computedBrachIds), true)
            if (this.locally && !this.obituary) {
              this.selectBranches(this.otherBranchIds, false)
              this.selectGroups(this.getGroupIds(this.otherBranchIds), false)
            }
          }
        },
        checkAllBranches(val) {
          const branchIds = this.branches.map(b => b.id).reduce((res, id) => ({...res, ...{[id]: val}}), {})
          const groupIds = this.branches.flatMap(b => b.groups.map(g => g.id)).reduce((res, id) => ({...res, ...{[id]: val}}), {})
          this.selections = { branchIds, groupIds }
        },
        getGroupIds(branchIds) {
          return this.branches.filter(branch => branchIds.includes(branch.id)).flatMap(branch => branch.groups.map(group => group.id))
        },
        selectBranches(ids, value) {
          const branchIds = ids.reduce((res, id) => ({...res, ...{[id]: value}}), this.selections.branchIds)
          this.selections = { ...this.selections, ...{ branchIds } }
        },
        selectGroups(ids, value) {
          const groupIds = ids.reduce((res, id) => ({...res, ...{[id]: value}}), this.selections.groupIds)
          this.selections = { ...this.selections, ...{ groupIds } }
        },
        topicDisabled(topic) {
          if (this.role === 'manager' && adminOnly.includes(topic)) {
            return true
          } else {
            return false
          }
        },
        branchDisabled(branch) {
          if (this.role === 'manager' && this.locally) {
            return this.otherBranchIds.includes(branch.id)
          } else {
            return this.emergency || this.obituary|| this.central
          }
        },
      },
      mounted() {
        // writeback
        this.selectBranches(this.writeback_branch_ids, true)
        this.selectGroups(this.writeback_group_ids, true)
        if (this.role === 'manager' && topics.find((t) => this[t]) === undefined) {
          this.obituary = true
        }
      },
    })
  }
})
